import { ReactNode } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { SearchField } from "@rentablo/components";

interface Props {
  filter: string;
  setFilter: (value: string) => void;
  addButton: ReactNode;
}

export const ActionButton = ({ filter, setFilter, addButton }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection={isMobile ? "column-reverse" : "row"}
      gap={3}
      width={isMobile ? "100%" : "auto"}
    >
      <SearchField
        value={filter}
        data-testid="depots-filter-field"
        onChange={(e) => setFilter(e.target.value)}
        sx={{
          "& input": {
            height: "28px",
          },
        }}
      />
      <Box
        display="flex"
        flexDirection="column"
        width={isMobile ? "100%" : "auto"}
      >
        {addButton}
      </Box>
    </Box>
  );
};
